/** Altura mínima (px) do painel para considerar janela do chat (barra verde ~60px; janela 400px+). */
var JIVO_CHAT_PANEL_MIN_HEIGHT = 400;

/** Observador global: esconde o botão flutuante só quando o chat Jivo está expandido (janela aberta).
 *  Considera "aberto" apenas um jdiv alto que contenha campo de mensagem (input/textarea), não a barra verde. */
function syncJivoChatOpenState() {
  const jivos = document.querySelectorAll('jdiv');
  let chatPanelOpen = false;
  for (let i = 0; i < jivos.length; i++) {
    var el = jivos[i];
    var h = el.offsetHeight || 0;
    if (h < JIVO_CHAT_PANEL_MIN_HEIGHT) continue;
    /* Janela do chat aberta costuma ter campo de mensagem visível; a barra verde não. */
    var hasInput = el.querySelector && el.querySelector('input, textarea, [contenteditable="true"]');
    if (hasInput) {
      chatPanelOpen = true;
      break;
    }
  }
  if (chatPanelOpen) {
    document.body.classList.add('jivo-chat-open');
  } else {
    document.body.classList.remove('jivo-chat-open');
  }
}

function startGlobalJivoObserver() {
  if (window.__floatingInfoJivoObserverStarted) return;
  window.__floatingInfoJivoObserverStarted = true;
  syncJivoChatOpenState();
  setInterval(syncJivoChatOpenState, 400);

  /* Quando o Jivo informa que o chat foi fechado/minimizado, garantir que o botão volte a aparecer. */
  var api = window.jivo_api;
  if (api && typeof api.addListener === 'function') {
    try {
      api.addListener('chat.closed', function () {
        document.body.classList.remove('jivo-chat-open');
      });
      api.addListener('chat.minimized', function () {
        document.body.classList.remove('jivo-chat-open');
      });
    } catch (e) {}
  }
}

class FloatingInfoButton {
  constructor(button, modal) {
    this.button = button;
    this.modal = modal;
    this.modalId = modal.dataset.modalId;
    this.isOpen = false;

    this.init();
  }

  init() {
    startGlobalJivoObserver();
    // Event listeners
    if (this.button) {
      this.button.addEventListener('click', (e) => {
        if (this.isOpen) {
          this.close();
        } else {
          this.open(e);
        }
      });
    }

    // Fechar ao clicar no overlay
    const overlay = this.modal.querySelector('.floating-info-modal__overlay');
    if (overlay) {
      overlay.addEventListener('click', () => this.close());
    }

    // Fechar ao clicar no botão de fechar
    const closeButton = this.modal.querySelector('.floating-info-modal__close');
    if (closeButton) {
      closeButton.addEventListener('click', () => this.close());
    }

    // Fechar com tecla ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    // Abrir JivoChat a partir do modal e fechar o botão flutuante
    if (this.modal) {
      this.modal.addEventListener('click', (e) => {
        const trigger = e.target && e.target.closest ? e.target.closest('[data-open-jivo-chat]') : null;
        if (!trigger) return;

        e.preventDefault();
        e.stopPropagation();

        // tornar o widget Jivo visível
        document.body.classList.add('jivo-visible');

        // fechar o modal e abrir o Jivo; o observador global esconde o botão quando o chat abrir
        this.close(true);
        this.openJivoChat();
      });
    }
  }

  openJivoChat() {
    const tryOpen = (attempt = 0) => {
      const api = window.jivo_api;

      if (api && typeof api.open === 'function') {
        api.open({ start: 'chat' });
        return;
      }

      if (api && typeof api.openChat === 'function') {
        api.openChat();
        return;
      }

      // aguarda o widget carregar
      if (attempt < 30) {
        setTimeout(() => tryOpen(attempt + 1), 250);
      }
    };

    tryOpen(0);
  }

  open(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.isOpen = true;
    this.modal.classList.add('is-open');
    document.body.classList.add('modal-open');
    this.updateButtonState(true);

    // Manter a barra de rolagem visível: não usar overflow hidden; bloquear scroll do fundo via JS
    document.body.style.overflowY = 'scroll';
    this._preventBackgroundScroll = (e) => {
      if (!this.modal || !this.modal.contains(e.target)) {
        e.preventDefault();
      }
    };
    document.addEventListener('wheel', this._preventBackgroundScroll, { passive: false });
    document.addEventListener('touchmove', this._preventBackgroundScroll, { passive: false });

    // Focar no primeiro elemento interativo do modal
    const firstFocusable = this.modal.querySelector('a, button, input, textarea, select');
    if (firstFocusable) {
      setTimeout(() => {
        firstFocusable.focus();
      }, 100);
    }
  }

  close(keepJivoVisible = false) {
    this.isOpen = false;
    this.modal.classList.remove('is-open');
    document.body.classList.remove('modal-open');
    document.body.style.overflowY = '';
    if (this._preventBackgroundScroll) {
      document.removeEventListener('wheel', this._preventBackgroundScroll, { passive: false });
      document.removeEventListener('touchmove', this._preventBackgroundScroll, { passive: false });
      this._preventBackgroundScroll = null;
    }
    this.updateButtonState(false);

    // Retornar foco para o botão
    if (this.button) {
      setTimeout(() => {
        this.button.focus();
      }, 100);
    }

    // opcional: re-ocultar o Jivo quando o modal for fechado manualmente
    // isso garante que o widget não reapareça sozinho em futuras páginas
    if (!keepJivoVisible && !this.isOpen) {
      document.body.classList.remove('jivo-visible');
    }
  }

  updateButtonState(isOpen) {
    if (!this.button) return;

    const defaultIcon = this.button.querySelector('.floating-info-button__icon--default');
    const closeIcon = this.button.querySelector('.floating-info-button__icon--close');

    if (isOpen) {
      // Modal aberto - mostrar X, esconder ícone padrão
      if (defaultIcon) {
        defaultIcon.style.display = 'none';
      }
      if (closeIcon) {
        closeIcon.style.display = 'block';
      }
      this.button.setAttribute('data-button-state', 'open');
      this.button.setAttribute('aria-label', 'Fechar');
    } else {
      // Modal fechado - mostrar ícone padrão, esconder X
      if (defaultIcon) {
        defaultIcon.style.display = 'block';
      }
      if (closeIcon) {
        closeIcon.style.display = 'none';
      }
      this.button.setAttribute('data-button-state', 'closed');
      this.button.setAttribute('aria-label', 'Abrir informações');
    }
  }
}

// Inicializar todos os botões flutuantes quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', () => {
  const floatingInfoButtons = document.querySelectorAll('.floating-info-button-wrapper');

  floatingInfoButtons.forEach((wrapper) => {
    const button = wrapper.querySelector('[data-modal-trigger]');
    const modal = wrapper.querySelector('.floating-info-modal');

    if (button && modal) {
      new FloatingInfoButton(button, modal);
    }
  });
});

// Também inicializar quando novos elementos são adicionados dinamicamente
if (typeof MutationObserver !== 'undefined') {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList && node.classList.contains('floating-info-button-wrapper')) {
          const button = node.querySelector('[data-modal-trigger]');
          const modal = node.querySelector('.floating-info-modal');

          if (button && modal && !modal.dataset.initialized) {
            modal.dataset.initialized = 'true';
            new FloatingInfoButton(button, modal);
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
